/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { UpdateStaffRoleMutationRequest, UpdateStaffRoleMutationResponse, UpdateStaffRolePathParams, UpdateStaffRole400, UpdateStaffRole401, UpdateStaffRole403, UpdateStaffRole404, UpdateStaffRole409, UpdateStaffRole500 } from "../../types/staffController/UpdateStaffRole.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { updateStaffRole } from "../../client/staffController/updateStaffRole.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const updateStaffRoleMutationKey = () => [{ url: '/api/organizations/:organizationId/staff/:staffId/role' }] as const

export type UpdateStaffRoleMutationKey = ReturnType<typeof updateStaffRoleMutationKey>

export function updateStaffRoleMutationOptions<TContext = unknown>(config: Partial<RequestConfig<UpdateStaffRoleMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = updateStaffRoleMutationKey()
        return mutationOptions<UpdateStaffRoleMutationResponse, ResponseErrorConfig<UpdateStaffRole400 | UpdateStaffRole401 | UpdateStaffRole403 | UpdateStaffRole404 | UpdateStaffRole409 | UpdateStaffRole500>, {organizationId: UpdateStaffRolePathParams["organizationId"], staffId: UpdateStaffRolePathParams["staffId"], data: UpdateStaffRoleMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ organizationId, staffId, data }) => {
            return updateStaffRole(organizationId, staffId, data, config)
          },
        })

}

/**
 * @summary Update staff member role
 * {@link /api/organizations/:organizationId/staff/:staffId/role}
 */
export function useUpdateStaffRole<TContext>(options: 
{
  mutation?: UseMutationOptions<UpdateStaffRoleMutationResponse, ResponseErrorConfig<UpdateStaffRole400 | UpdateStaffRole401 | UpdateStaffRole403 | UpdateStaffRole404 | UpdateStaffRole409 | UpdateStaffRole500>, {organizationId: UpdateStaffRolePathParams["organizationId"], staffId: UpdateStaffRolePathParams["staffId"], data: UpdateStaffRoleMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<UpdateStaffRoleMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? updateStaffRoleMutationKey()

          const baseOptions = updateStaffRoleMutationOptions(config) as UseMutationOptions<UpdateStaffRoleMutationResponse, ResponseErrorConfig<UpdateStaffRole400 | UpdateStaffRole401 | UpdateStaffRole403 | UpdateStaffRole404 | UpdateStaffRole409 | UpdateStaffRole500>, {organizationId: UpdateStaffRolePathParams["organizationId"], staffId: UpdateStaffRolePathParams["staffId"], data: UpdateStaffRoleMutationRequest}, TContext>
          

          return useMutation<UpdateStaffRoleMutationResponse, ResponseErrorConfig<UpdateStaffRole400 | UpdateStaffRole401 | UpdateStaffRole403 | UpdateStaffRole404 | UpdateStaffRole409 | UpdateStaffRole500>, {organizationId: UpdateStaffRolePathParams["organizationId"], staffId: UpdateStaffRolePathParams["staffId"], data: UpdateStaffRoleMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<UpdateStaffRoleMutationResponse, ResponseErrorConfig<UpdateStaffRole400 | UpdateStaffRole401 | UpdateStaffRole403 | UpdateStaffRole404 | UpdateStaffRole409 | UpdateStaffRole500>, {organizationId: UpdateStaffRolePathParams["organizationId"], staffId: UpdateStaffRolePathParams["staffId"], data: UpdateStaffRoleMutationRequest}, TContext>
      
}